import React, { FC, memo } from 'react';
import styled from 'styled-components';

import Landing from './landing';
import QuotationForm from './quotation-form';
export const Container = styled.div`
  @media (max-width: 576px) {
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 15px;
    margin-left: -15px;
    margin-right: -15px;
  }
  background-color: #fff;
`;

const Quotation: FC = () => {
  return (
    <Container>
      <QuotationForm />
      <Landing />
    </Container>
  );
};

export default memo(Quotation);
